import React from 'react';
import { useTheme } from '../theming/default_theme'
import Menu from './Menu/Menu';
import Header from './Header';
import { start } from 'repl';
import Hospitals from './Hospitals';
import FileUploadModal from './FileUploadModal';
import Referrals from './Referrals';
import { useAppSelector } from '../store/hooks';
import SpectacleRequests from './SpectacleRequests';
import VisionAmbassadors from './VisionAmbassadors';
import SpectacleFileUploadModel from './SpectacleFileUploadModel';
// import VisionAmbassadors from './VisionAmbassadors';

const LandingPage: React.FC = () => {
    const theme = useTheme();
    const [showModal, setShowModal] = React.useState(false);
     const [showSpectacleFileUploadModal, setshowSpectacleFileUploadModal] = React.useState(false);
    const menuSelected = useAppSelector((state) => state.menu.menuSelected);



    const onClose = () => {
        setShowModal(false);

    }

    const onCloseSpectacleRequestDialog = () => {
        setshowSpectacleFileUploadModal(false);
    }

    return (
        <>

            <div className={` flex flex-row justify-start items-start h-screen w-screen}`}>

                <Menu />


                <div className="flex flex-col justify-start items-start w-full h-full">
                    <Header />
                    {menuSelected === 'Hospitals' && <Hospitals showModal={showModal} setShowModal={setShowModal} menuSelected={menuSelected} />}
                    {menuSelected === 'Referrals' && <Referrals showModal={showModal} setShowModal={setShowModal} menuSelected={menuSelected} />}
                    {menuSelected === 'Vision Ambassadors' && <VisionAmbassadors showModal={showModal} setShowModal={setShowModal} menuSelected={menuSelected}/>}
                    {menuSelected === 'Spectacle Requests' && <SpectacleRequests showModal={showSpectacleFileUploadModal} setShowModal={setshowSpectacleFileUploadModal} menuSelected={menuSelected} />}
                    
                </div>
            </div>
            {showModal && (<FileUploadModal onClose={onClose} />)}
            {showSpectacleFileUploadModal && (<SpectacleFileUploadModel onClose={onCloseSpectacleRequestDialog} />)}



        </>

    );
};

export default LandingPage;